import { useTranslation } from "next-i18next";
import { getValue, vehicleValidation } from "@talladega/helpers";
import { FieldValues } from "react-hook-form";
import { FormInputProps } from "@talladega/types";
import { Form } from ".";

type Props<T extends FieldValues> = {
  required?: boolean;
  ref?: React.Ref<HTMLInputElement>;
} & Omit<FormInputProps<T>, "rules">;

export const YearInput = <TFormValues extends FieldValues>({
  name,
  register,
  errors,
  required = false,
  ref,
  ...props
}: Props<TFormValues>): JSX.Element => {
  const { t } = useTranslation(["common"]);

  const error = name && errors ? getValue(errors, name) : undefined;

  return (
    <Form.Input
      id="year"
      type="number"
      label={t("common:year") || undefined}
      feedback={error?.message?.toString()}
      status={error ? "error" : "default"}
      maxLength={vehicleValidation.year.maxLength}
      ref={ref}
      {...(register &&
        name &&
        register(name, {
          valueAsNumber: true,
          required: {
            value: required,
            message: t("common:required"),
          },
          maxLength: {
            value: vehicleValidation.year.maxLength,
            message: t("common:invalid_year"),
          },
          validate: {
            invalidYear: (value: number | null) => {
              const isValid = vehicleValidation.year.validYear(value);
              return isValid ? true : t("common:invalid_year") || undefined;
            },
            exceedsCurrentYear: (value: number | null) => {
              const isBeforeCurrentYear =
                vehicleValidation.year.beforeCurrentYear(value);
              return isBeforeCurrentYear
                ? true
                : t("common:invalid_year") || undefined;
            },
          },
        }))}
      {...props}
    />
  );
};

export default {};
